export const KV_UNIT_TYPES = [
  'Meters',
  'Millimeters',
  'FeetAndInches',
  'Feet',
  'Inches',
] as const

export type KVUnitType = (typeof KV_UNIT_TYPES)[number]

export function normalizeKVUnit(u: unknown): KVUnitType | undefined {
  if (!u) return undefined
  const s = String(u).trim().toLowerCase()
  switch (s) {
    case 'm':
    case 'meter':
    case 'meters':
      return 'Meters'
    case 'ft':
    case 'foot':
    case 'feet':
      return 'Feet'
    case 'in':
    case 'inch':
    case 'inches':
      return 'Inches'
    case 'mm':
    case 'millimeter':
    case 'millimeters':
      return 'Millimeters'
    case 'feetandinches':
    case 'feet and inches':
    case 'ft/in':
      return 'FeetAndInches'
    default:
      return undefined
  }
}
